// Store mínimo de bloqueio de trial (κ+1). Ponte entre o player (que detecta o
// trial esgotar AO VIVO via heartbeat) e o TrialGate global (que cobre o app).
//
// Por quê: o gate faz polling a cada ~8s, mas quando o trial esgota DURANTE o
// vídeo o bloqueio tem que ser imediato. O player chama setTrialBlocked(true)
// assim que o guard vira blocked → o gate reage na hora. O gate, ao confirmar
// via API que não está mais bloqueado (pós-pagamento), limpa.

import { useSyncExternalStore } from 'react'

let blocked = false
const listeners = new Set<() => void>()

function emit(): void {
  for (const l of listeners) l()
}

/** Marca/desmarca o bloqueio de trial. Idempotente (no-op se não mudou). */
export function setTrialBlocked(value: boolean): void {
  if (blocked === value) return
  blocked = value
  emit()
}

export function getTrialBlocked(): boolean {
  return blocked
}

/** Hook reativo pro TrialGate. */
export function useTrialBlocked(): boolean {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb)
      return () => listeners.delete(cb)
    },
    getTrialBlocked,
    getTrialBlocked,
  )
}
